// extracted by mini-css-extract-plugin
module.exports = {"root":"EditComponent_root__2EKxT","editText":"EditComponent_editText__1GEbE"};